import { X_API_KEY } from "./authentication";

const key = "RECENT_PROJECTS";

function getApiKey() {
    const api = localStorage.getItem(X_API_KEY);
    return api ? api : '';
}

export function addRecentProject(project) {
    let recentProjects = getRecentProjects();

    if (project === null || project.id === null){
        return recentProjects;
    }

    if (project.name !== null && project.name.trim() !== '') {

        project.updateDate = new Date();
        recentProjects[project.id] = project;

        const allRecentProjects = getAllRecentProjects();
        allRecentProjects[getApiKey()] = recentProjects;
        localStorage.setItem(key, JSON.stringify(allRecentProjects));
    } else {
        removeRecentProject(project.id)
    }

    return recentProjects;
}

export function removeRecentProject(projectId) {
    let recentProjects = getRecentProjects();
    delete recentProjects[projectId];

    const allRecentProjects = getAllRecentProjects();
    allRecentProjects[getApiKey()] = recentProjects;
    localStorage.setItem(key, JSON.stringify(allRecentProjects));

    return recentProjects;
}

export function clearRecentProjects() {
    const allRecentProjects = getAllRecentProjects();
    delete allRecentProjects[getApiKey()];
    localStorage.setItem(key, JSON.stringify(allRecentProjects));
    return {};
}

function getAllRecentProjects() {
    try {
        const allRecentProjects = JSON.parse(localStorage.getItem(key));
        if (allRecentProjects === undefined || allRecentProjects === null || allRecentProjects === '') {
            return {};
        }
        return allRecentProjects;
    } catch (e) {
        return {};
    }
}

export function getRecentProjects() {
    try {
        const allRecentProjects = getAllRecentProjects();
        const recentProjects = allRecentProjects ? allRecentProjects[getApiKey()] : {};
        if (recentProjects === undefined || recentProjects === null || recentProjects === '') {
            return {};
        }
        return recentProjects;
    } catch (e) {
        return {};
    }
}
